import { useEffect, useState } from "react";
import { baseUrl } from "../../connections";
import { appendAuthToken } from "../../utils/authSession";

export const useStateData = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [payload, setStateData] = useState(null);

  useEffect(() => {
    if (payload) {
      setIsLoading(true);

      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      appendAuthToken(headers);

      const params = JSON.stringify(payload);

      const requestOptions = {
        method: "GET",
        headers: headers,
        redirect: "follow",
      };

      fetch(`${baseUrl}/state/list/by/country/${payload}`, requestOptions)
        .then(async (response) => {
          const res = await response.text();
          if (response.status !== 200) {
            throw res;
          }
          return JSON.parse(res);
        })
        .then((result) => {
          setData([...result.data]);
          setError(false);
          setIsLoading(false);
        })
        .catch((err) => {
          setError(err);
          setIsLoading(false);
        });
    }
  }, [payload]);

  return {
    stateData: data,
    isLoading,
    error,
    setStateData,
  };
};
